import useWindowDimensions from './useWindowDimensions';

export const MOBILE_BREAKPOINT = 768;

export default function useIsMobile(): boolean {
    const { width } = useWindowDimensions();
    return width <= MOBILE_BREAKPOINT;
}
